import { cn } from '@/lib/utils'
import React from 'react'
import { AgentLogoIcon } from '../agent/assets'
import { IconButton } from '../common/icon-button'
import { ExpandIcon } from '../ui/icon'
import { useTranslation } from 'react-i18next'
import { ActorNewIcon, KnowledgeIcon, MaterialIcon, VoiceNewIcon } from '../assets/assets'
import { Image } from '../common/image'
import { AgentCreditsIcon } from '../agent-creation/assets/agent-credits-icon'
import { EmptyState } from '../agent-creation/content-placeholder'
import { LogOut, Plus, Settings } from 'lucide-react'
import { RecordsIcon } from '../agent-creation/assets/records-icon'
import { VideoTypeIcon } from '@/components/agent-creation/assets/video-type-icon';
import { PodcastTypeIcon } from '@/components/agent-creation/assets/podcast-type-icon';
import { MomentsTypeIcon } from '@/components/agent-creation/assets/moments-type-icon';
import { PostTypeIcon } from '@/components/agent-creation/assets/post-type-icon';
import { ArticleTypeIcon } from '@/components/agent-creation/assets/article-type-icon';
import { AiCreationTypeIcon } from '@/components/agent-creation/assets/ai-creation-icon';
import { Script } from '../common/script'
import { PaperclipIcon } from '../agent-creation/assets/paperclip-icon'
import { OutputLangSelect } from '../agent-creation/output-lang-select'
import { LiveScriptButton } from '../agent-creation/live-script-button'
import { MaterialRangeSettingButton } from '../agent-creation/material-range-setting-button'
import { SendIcon } from '../agent-creation/assets/send-icon'
import { CreationIcon } from '../agent-creation/assets/creation-icon'
import { useLogout } from '@/hooks/use-logout'

/** 主站背景页 */
export const MainBackgroundPage = () => {
  const { t } = useTranslation();
  const { handleLogout } = useLogout();

  const assetsTabs = [
    { title: t('assets.material_title'), icon: <MaterialIcon className='size-5 text-[rgba(13,13,13,1)]' /> },
    { title: t('assets.knowledge_title'), icon: <KnowledgeIcon className='size-5 text-[rgba(13,13,13,1)]' /> },
    { title: t('assets.actor'), icon: <ActorNewIcon className='size-5 text-[rgba(13,13,13,1)]' /> },
    { title: t('assets.voice'), icon: <VoiceNewIcon className='size-5 text-[rgba(13,13,13,1)]' /> },
  ]

  const workflowTabs = [
    {
      type: 1,
      name: t("agent_creation.video"),
      icon: <VideoTypeIcon className={cn('size-5 text-[rgba(102,112,133,1)]')} />,
    },
    {
      type: 6,
      name: t("agent_creation.ai_creation"),
      icon: <AiCreationTypeIcon className={cn('size-5 text-[rgba(102,112,133,1)]')} />,
    },
    {
      type: 4,
      name: t("agent_creation.post"),
      icon: <PostTypeIcon className={cn('size-5 text-[rgba(102,112,133,1)]')} />,
    },
    {
      type: 5,
      name: t("agent_creation.article"),
      icon: <ArticleTypeIcon className={cn('size-5 text-[rgba(102,112,133,1)]')} />,
    },
    {
      type: 2,
      name: t("agent_creation.podcast"),
      icon: <PodcastTypeIcon className={cn('size-5 text-[rgba(102,112,133,1)]')} />,
    },
    {
      type: 3,
      name: t("agent_creation.moments"),
      icon: <MomentsTypeIcon className={cn('size-5 text-[rgba(102,112,133,1)]')} />,
    },
  ]

  return (
    <div className={cn("flex h-screen bg-background")}>
      {/* 左侧边栏 */}
      <aside
        className={cn(
          "relative z-10 flex flex-col transition-all duration-300 ease-in-out",
          "min-w-[260px] max-w-[260px]",
          "bg-white border-r border-sidebar-border",
          "h-full pb-2 px-3 overflow-hidden"
        )}
      >
        <div className={cn("flex items-center transition-all duration-300 z-10 h-[62px] flex-shrink-0 justify-between")}>
          <div
            className={cn(
              "ml-2 transition-all duration-300 ease-in-out overflow-hidden",
              "w-[7rem] opacity-100"
            )}
          >
            <AgentLogoIcon className="w-[5.5rem]" />
          </div>
          <IconButton
            className={cn(
              "size-9 !rounded-[6px] transition-all  hover:bg-[rgba(16,24,40,0.05)]",
            )}
            icon={<ExpandIcon className="w-5 h-5 text-[rgba(13,13,13,1)]" />}
          />
        </div>
        <div className={cn(
          "w-full flex flex-col overflow-y-auto scrollbar-hide gap-2 z-10 pb-5",
        )}>
          <section className="h-full">
            <div className="flex-1 space-y-4 overflow-y-auto scrollbar-hide flex-shrink-0">
              <div className="space-y-0.5">

                <div className='p-2 py-2 rounded-[6px] flex items-center'>
                  <CreationIcon className='size-5 text-[rgba(13,13,13,1)] mr-2 flex-shrink-0' />
                  <span className='text-sm text-[#0D0D0D] select-none whitespace-nowrap'>创作</span>
                </div>
                <div className="pl-2 text-sm py-1.5 text-[rgba(102,112,133,1)] whitespace-nowrap">
                  {t('assets.title')}
                </div>
                {assetsTabs.map((tab) => (
                  <div
                    className='group relative flex items-center p-2 py-1.5 rounded-[6px] transition-colors duration-200 hover:bg-[rgba(16,24,40,0.05)] cursor-pointer'
                  >
                    <div className='relative size-8 flex items-center justify-center w-6 h-6 mr-2 flex-shrink-0'>
                      <div className='transition-all duration-300 ease-in-out flex items-center justify-center mr-2 pl-2'>
                        {tab.icon}
                      </div>
                    </div>
                    <div className="text-sm text-[#0D0D0D] select-none whitespace-nowrap">
                      {tab.title}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
        <div className='mt-auto'>
          <div className="mt-auto h-12 w-full mb-5 border rounded-[12px] flex items-center pl-2 gap-2">
            <AgentCreditsIcon />
            <span>0</span>
          </div>
          <div className={cn(
            "flex items-center justify-between gap-[10px] border-t border-sidebar-border pt-[14px] px-2 pb-1.5 transition-all z-10",
          )}>
            <Image
              src={'https://sg-miuta-resource.oss-accelerate.aliyuncs.com/push_images/volcengineSeedream_1774607095548_0e2076c8882141eebe42e5c53381f554_887b13/20260327_182512.95333468.jpg'}
              alt="Avatar"
              className="size-7 rounded-full"
            />
            <IconButton icon={<LogOut className='size-5 text-[rgba(102,112,133,1)]' />} onClick={handleLogout} />
          </div>
        </div>
      </aside>
      {/* 右侧内容 */}
      <div className='flex flex-1 w-full h-screen overflow-hidden'>
        <div className='h-screen flex-1 flex flex-col items-center overflow-hidden relative pt-5 bg-[rgba(249,250,251)]'>
          <div className='flex items-center gap-5 absolute top-0 right-0 max-w-max pt-8 px-8'>
            <RecordsIcon className="w-5 h-5" />
            <Settings className="w-5 h-5" />
          </div>
          <div className='flex flex-1 flex-col-reverse items-center gap-5 pb-1 overflow-y-auto ml-4'>
            <div className='mt-auto'></div>
            <EmptyState className='max-w-[620px] mt-10' />
          </div>
          <div>
            <div className='relative mx-auto mb-4 border border-[rgba(234,236,240,1)] w-[680px] bg-white rounded-[20px] shadow-lg transition-all duration-300 ease-in-out overflow-hidden min-h-[94px]'
            >
              <div className='grid transition-all duration-300 ease-in-out grid-rows-[1fr] opacity-100'>
                <div className='overflow-hidden'>
                  <div className='flex items-center px-[13px] py-4 gap-1.5 select-none'>
                    {workflowTabs?.map((item) => (
                      <div
                        key={item.type}
                        className={cn(
                          'group py-1.5 px-[10px] flex items-center cursor-pointer hover:bg-[rgba(16,24,40,0.05)] max-w-max rounded-[8px] gap-2 transition-all',
                        )}
                      >
                        {item.icon}
                        <span className={cn(
                          'text-[rgba(102,112,133,1)] text-sm',
                        )}>{item.name}</span>
                      </div>
                    ))}
                  </div>
                  <div className='w-full flex items-start px-[13px]'>
                    <div className='min-w-[52px] max-w-[52px] h-[70px] rounded-[8px] bg-[#f3f4f6]'>
                      <button className='relative flex flex-col justify-center items-center gap-1 rounded-[10px] px-2.5 py-2 cursor-pointer min-w-[52px] max-w-[52px] h-[70px] bg-[#f3f4f6] hover:scale-110 transition-all'>
                        <Plus className="size-5 text-[rgba(152,162,179,1)]" />
                      </button>
                    </div>
                    <div className='relative w-full ml-[9px]'>
                      <Script
                        value={''}
                        tooltip={false}
                        onChange={() => { }}
                        maxLineHeight={6}
                        onBlur={() => false}
                        className={cn(
                          "h-[70px] pl-[3px] leading-[24px] tracking-[0.8px]",
                        )}
                        scriptPlaceholder={t('agent_creation.input.script_placeholder')}
                      />
                    </div>
                  </div>
                  <div className='w-full'>
                    <div className='flex items-end m-4 mt-[10px] justify-between'>
                      <div className='flex items-center'>
                        <div className='mr-4'><PaperclipIcon /></div>
                        <OutputLangSelect
                          outLang={'zh-HK'}
                          setOutLang={() => { }}
                        />
                        <LiveScriptButton
                          liveStreamScript={false}
                          setLiveStreamScript={() => { }}
                        />
                        <MaterialRangeSettingButton
                          scene={null}
                        />
                      </div>
                      <div className='flex items-center gap-3'>
                        <div className='flex items-center'>
                          <IconButton
                            aria-label={t('agent_creation.input.send')}
                            className={cn(
                              "w-9 h-9 transition-colors",
                              "text-[rgba(208,213,221,1)] hover:bg-transparent cursor-not-allowed",
                              "text-[rgba(16,24,40,1)] cursor-pointer",
                            )}
                            icon={<SendIcon className="w-9 h-9" />}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}
